import { BaseDraft } from '@qover/domain';
import type { BaseDraftProps } from '@qover/domain';
import { Risk } from './Risk';
import { Terms } from './Terms';
import type { RiskProps } from './Risk';
import type { Variant, TermsProps } from './Terms';

export interface DraftProps extends BaseDraftProps {
  risk: RiskProps;
  terms: TermsProps;
}

export class Draft extends BaseDraft {
  risk: Risk;
  terms: Terms;

  constructor(draft: DraftProps) {
    super(draft);

    this.risk = new Risk(draft.risk);
    this.terms = new Terms(draft.terms);
  }

  initLocaleAndProduct(locale: string): void {
    super.initLocaleAndProduct(locale, 'TESLA');
  }

  updateCountry(locale: string): void {
    super.updateCountry(locale);

    this.terms.resetOnCountryChange();
  }

  upsell(variant: Variant): void {
    this.terms.upsell(variant);
  }

  updateRisk(payload: RiskProps) {
    this.risk = new Risk(payload);
  }

  updateTerms(payload: TermsProps) {
    this.terms = new Terms(payload);
  }

  buildPriceInfoPayload(): Record<string, string | number | boolean> {
    const defaultPayload = super.buildPriceInfoPayload();

    return defaultPayload;
  }
}
